import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IOrganizationDetails } from 'src/types/client/clients';

interface ClientResponse {
  data: {
    clientDetails: IOrganizationDetails;
  };
}

interface OrganizationField {
  name: string;
  label: string;
  placeholder: string;
  inputType?: string;
}

@Component({
  selector: 'app-client-organization',
  templateUrl: './client-organization.component.html',
  styleUrls: ['./client-organization.component.css']
})
export class ClientOrganizationComponent implements OnInit {
  @Input() clientID: string = '';
  
  hasError: boolean = false;
  errorMessage: string = '';
  @Input() clientCorporation: string = '';
  organizationDetails:any;
  displayLoader: boolean = true;
  organizationFields: OrganizationField[] = [];

  constructor(private http: HttpClient) {
   }
   setupOrganizationFields(): void {
    this.organizationFields = [
      { name: 'name', label: 'Company Name', placeholder: 'Company Name' },
      { name: 'customText2', label: 'ABN', placeholder: 'ABN' },
      { name: 'address_line1', label: 'Address', placeholder: 'Address' },
      { name: 'address_city', label: 'City', placeholder: 'City' },
      { name: 'address_state', label: 'State', placeholder: 'State' },
      { name: 'address_zip', label: 'Post Code', placeholder: 'Post Code' },
      { name: 'customText3', label: 'Billing Email', inputType: 'email', placeholder: 'Billing Email' }
    ];
  }

  ngOnInit(): void {
    this.getOrganizationDetails();
  }
 
  getOrganizationDetails() {
    const url = `${environment.apiConfig.uri}/admin/AdminClientContact/GetClientOrganization?clientId=${this.clientID}`;
    this.http.get(url, {}).subscribe(
        (response: any) => {
          this.organizationDetails = response.data;
          this.setupOrganizationFields();
          this.displayLoader = false;
        },
        (error) => {
          console.error('Error fetching client organization details:', error);
          this.displayLoader = false;
        }
      );
  }

   getFieldValue(field: OrganizationField): any {
      return this.organizationDetails && this.organizationDetails[field.name];
    }

}
